import { styled } from '@acko-tech/building-blocks.ui.common';

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

export const Icon = styled.svg`
    fill: none;
    stroke: white;
    stroke-width: 2px;
`;

export const StyledCheckbox = styled.div`
    display: inline-block;
    width: ${(props) => props.width || '16px'};
    height: ${(props) => props.height || '16px'};
    background: ${(props) =>
        props.checked ? (props.color ? props.color : '#7C47E1') : '#ffffff'};
    border: 1px solid ${(props) => (props.checkbox ? '#ffffff' : '#C8D0DB')};
    border-radius: 5px;
    transition: all 150ms;
    ${HiddenCheckbox}:focus + & {
        box-shadow: 0 0 0 3px pink;
    }
    ${Icon} {
        visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
    }
    cursor: pointer;
`;
